<template>
  <!-- If no truncation needed, just show the value -->
  <div v-if="!needsTruncation">
    {{ joinedValue }}
  </div>

  <!-- If truncation needed, use ExpandableCell -->
  <ExpandableCell v-else :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      {{ collapsedValue }}
    </template>
    <!-- Expanded content -->

    <template #expanded>
      <div v-for="(arrayValue, arrayIndex) in arrayValues" :key="arrayIndex">
        <div class="pb-1">{{ arrayValue }}</div>
      </div>
    </template>
  </ExpandableCell>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();

const { cell, column } = props;

// Ensure we always work with an array, even if a single string was passed
const arrayValues = computed(() => {
  const value = cell.meta?.('rawvalue') ?? cell.value;
  return Array.isArray(value) ? value : [value];
});

// Joined string value
const joinedValue = computed(() => {
  return arrayValues.value.join(', ');
});

// Check if truncation is needed
const needsTruncation = computed(() => {
  const truncateLength = column?.truncateLength;
  if (!truncateLength) return false;
  return joinedValue.value.length > truncateLength;
});

// Truncate the joined string if truncateLength is set
const collapsedValue = computed(() => {
  const truncateLength = column?.truncateLength;

  if (!truncateLength || !needsTruncation.value) {
    return joinedValue.value;
  }

  return joinedValue.value.slice(0, truncateLength) + '...';
});
</script>
